(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxStatusClassDialogController', TaxStatusClassDialogController);

    TaxStatusClassDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaxStatusClass', 'TaxClass', 'TaxStatus'];

    function TaxStatusClassDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaxStatusClass, TaxClass, TaxStatus) {
        var vm = this;
        vm.taxStatusClass = entity;
        vm.taxclasses = TaxClass.query();
        vm.taxstatuses = TaxStatus.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:taxStatusClassUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.taxStatusClass.id !== null) {
                TaxStatusClass.update(vm.taxStatusClass, onSaveSuccess, onSaveError);
            } else {
                TaxStatusClass.save(vm.taxStatusClass, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
